// ** Router Import
import Router from './router/Router';
import CacheBuster from 'react-cache-buster';
import json from '../package.json';

const App = () => {
    const isProduction = process.env.NODE_ENV === 'production';
    console.log('VERSION', json.version);
    return (
        <CacheBuster
            currentVersion={json.version}
            isEnabled={isProduction} //If false, the library is disabled.
            isVerboseMode={false} //If true, the library writes verbose logs to console.
            metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
        >
            <Router/>
        </CacheBuster>
    );
};
export default App;
